import { Provider } from '@angular/core';
import { InlineLoader, provideTranslocoScope } from '@jsverse/transloco';

/**EXT-5702: Transloco scope for jfw-platform-portal's own (app-level) text.
 * Keys are addressed as `platformPortal.<feature>.<role>` from a template.
 *
 * Translations are bundled with an inline loader rather than fetched over
 * HTTP, the same way the `shared` scope is (see
 * `@jfw/angular/shared/i18n`'s `provideSharedTranslocoScope`): no extra
 * request on first load, and no `angular.json` assets change. Keys without a
 * Spanish value yet fall back to English (app.config's `fallbackLang`) until
 * EXT-5706 fills in es.json.
 */
export const PLATFORM_PORTAL_TRANSLOCO_SCOPE = 'platformPortal';

export const PLATFORM_PORTAL_TRANSLOCO_LOADER: InlineLoader = {
  en: () => import('../../assets/i18n/en.json').then((m) => m.default),
  es: () => import('../../assets/i18n/es.json').then((m) => m.default),
};

export function providePlatformPortalTranslocoScope(): Provider[] {
  return provideTranslocoScope({
    scope: PLATFORM_PORTAL_TRANSLOCO_SCOPE,
    loader: PLATFORM_PORTAL_TRANSLOCO_LOADER,
  });
}
